/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

//  SiteVision tabs (Modified)

/*!
 * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=8f4adb60d8a8b0389abaeaa54547e685)
 * Config saved to config.json and https://gist.github.com/8f4adb60d8a8b0389abaeaa54547e685
 */
+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(window.$svjq);

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var SvTab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  SvTab.VERSION = '3.3.7'

  SvTab.TRANSITION_DURATION = 150

  SvTab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.sv-dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('sv-active')) return

    var $previous = $ul.find('.sv-active:last a')
    var hideEvent = $.Event('hide.bs.sv-tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.sv-tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.sv-tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.sv-tab',
        relatedTarget: $previous[0]
      })
    })
  }

  SvTab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .sv-active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('sv-active')
        .find('> .sv-dropdown-menu > .sv-active')
          .removeClass('sv-active')
        .end()
        .find('[data-toggle="sv-tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('sv-active')
        .find('[data-toggle="sv-tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.sv-dropdown-menu').length) {
        element
          .closest('li.sv-dropdown')
            .addClass('sv-active')
          .end()
          .find('[data-toggle="sv-tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.sv-tab')

      if (!data) $this.data('bs.sv-tab', (data = new SvTab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.svTab

  $.fn.svTab             = Plugin
  $.fn.svTab.Constructor = SvTab


  // TAB NO CONFLICT
  // ===============

  $.fn.svTab.noConflict = function () {
    $.fn.svTab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.sv-tab.data-api', '[data-toggle="sv-tab"]', clickHandler)

}(window.$svjq);
